/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";

interface Props {
	handlePassAll: () => void;
	handleResetAll: () => void;
	filter: string;
	setFilter: (filter: string) => void;
}

const PAMediaCleaningTableHeader: React.FC<Props> = ({ handlePassAll, handleResetAll, filter, setFilter }) => {
	const { t } = useTranslation();
	return (
		<div className="px-8 py-4 border-b border-slate-100 bg-slate-50/50 flex justify-between items-center">
			<div className="flex items-center gap-3">
				<div className="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center">
					<span className="material-symbols-outlined text-[#FF7043] text-xl mb-2">
						fact_check
					</span>
				</div>
				<h3 className="text-xs font-black text-[#1E293B] uppercase tracking-[0.15em]">
					{t("postAutoclaveProcess.mediaCleaning.platesAssessmentGrid")}
				</h3>
			</div>

			<div className="flex items-center gap-8">
				<div className="flex items-center gap-4 bg-white px-4 py-1 rounded-xl border border-slate-200">
					<p className="text-[10px] font-black text-slate-400 uppercase tracking-widest border-r border-slate-100 pr-4 m-0">
						{t("postAutoclaveProcess.mediaCleaning.globalActions")}
					</p>
					<button
						onClick={handlePassAll}
						className="!bg-white text-[10px] font-black text-emerald-600 uppercase tracking-widest hover:text-emerald-700 flex items-center gap-1.5 border-none"
					>
						<span className="material-symbols-outlined text-sm">
							done_all
						</span>
						{t("postAutoclaveProcess.mediaCleaning.passAll")}
					</button>
					<button
						onClick={handleResetAll}
						className="!bg-white text-[10px] font-black text-slate-400 uppercase tracking-widest hover:text-slate-600 flex items-center gap-1.5 border-none"
					>
						<span className="material-symbols-outlined text-sm">
							restart_alt
						</span>
						{t("postAutoclaveProcess.mediaCleaning.resetAll")}
					</button>
				</div>

				{/* <div className="flex bg-slate-100 p-1 rounded-xl border border-slate-200">
					<button
						onClick={() => setFilter("all")}
						className={`px-4 py-1.5 text-[10px] font-black uppercase tracking-widest rounded-lg transition-all border-none ${filter === "all" ? "bg-white text-[#1E293B] shadow-sm" : "text-slate-400"}`}
					>{t("postAutoclaveProcess.mediaCleaning.all")}</button>
					<button
						onClick={() => setFilter("fail")}
						className={`px-4 py-1.5 text-[10px] font-black uppercase tracking-widest rounded-lg transition-all border-none ${filter === "fail" ? "bg-white text-red-600 shadow-sm" : "text-slate-400"}`}
					>{t("postAutoclaveProcess.mediaCleaning.failedOnly")}</button>
				</div> */}
				
			</div>
		</div>
	);
};

export default PAMediaCleaningTableHeader;
